var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"toast fade show",attrs:{"data-autohide":_vm.autohide}},[_c('div',{staticClass:"toast-header"},[_vm._t("title")],2),_c('div',{staticClass:"toast-body"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }